import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Hourglass } from 'lucide-react';

/**
 * Lot 1 (2026-09-03) — plafond IA mensuel atteint (7 €/membre, autoship 60 €).
 * Encart calme : le membre garde son pipeline, ses relances et ses publications.
 */
export function QuotaReachedNotice({ className = '' }: { className?: string }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div role="status" className={`card flex items-start gap-3 p-4 ${className}`}>
      <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-violet/10 text-violet">
        <Hourglass size={15} />
      </span>
      <div className="min-w-0">
        <p className="text-[14px] font-700 text-ink">{t('quota.title')}</p>
        <p className="mt-1 text-[12.5px] leading-[1.5] text-ink/60">{t('quota.body')}</p>
        <button
          type="button"
          onClick={() => navigate('/prospects')}
          className="mt-2.5 text-[12.5px] font-700 text-violet hover:underline"
        >
          {t('quota.cta')}
        </button>
      </div>
    </div>
  );
}
